import React from 'react';
import { OptionProps } from 'react-select';
import cn from 'classnames';

import { IProjectWorkflow } from '@interfaces/portal/projects';

import styles from './WorkflowSelectOption.module.scss';

const WorkflowSelectOption = (props: OptionProps<IProjectWorkflow>) => {
	const {
		selectOption,
		data: { title, statuses },
	} = props;

	const handleSelect = () => {
		selectOption(props.data);
	};

	return (
		<div
			className={cn(styles.presetsOption, {
				[styles.active]: props.isSelected,
			})}
			onClick={handleSelect}
		>
			<div className={styles.label}>
				{title}
			</div>
			<div className={styles.subText}>
				{statuses}
			</div>
		</div>
	);
};

export default WorkflowSelectOption;
